import {
  BASE_PATHS as COMMON_BASE_PATHS,
  PATHS as COMMON_PATHS,
} from '@belong/common';

// TODO: Let's not keep adding new paths here, and whenever you see the chance, change the import from routes/paths to @belong/common
export const BASE_PATHS = COMMON_BASE_PATHS;

// TODO: Let's not keep adding new paths here, and whenever you see the chance, change the import from routes/paths to @belong/common
export const PATHS = COMMON_PATHS;
